import useDataFetching from 'hooks/useDataFetching';
import { config } from 'variables/config';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from 'components/card';
import { useParams } from 'react-router-dom';
import PreloaderSpinner from 'components/PreloaderSpinner';
import { checkIsValidPermit } from 'utils';
import AddEmployer from './AddEmployer';
import { useDisclosure, Badge } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import { formatNumber } from 'utils';
import dayjs from 'dayjs';
import { getExpiredPermitDate } from 'utils';
import { FromArchiveIcon } from 'components/TableIcon';
import { FromTheFieldIcon } from 'components/TableIcon';
import { checkIsValidPermitDate } from 'utils';
import {
  Alert,
  AlertTitle,
  AppBar,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  Divider,
  Fab,
  IconButton,
  Slide,
  TextField,
  Toolbar,
  Typography,
  capitalize,
} from '@mui/material';
import MuiSelect from 'components/MuiSelect';
import {
  BsArrowLeftCircleFill,
  BsBoxArrowLeft,
  BsGit,
  BsPlus,
  BsPlusCircleDotted,
  BsSafe,
  BsTrash2Fill,
} from 'react-icons/bs';
import { NotFoundResults } from 'components/Utils';
import MuiTable from 'components/MuiTable';
import { getEmployerHeader } from 'Constaints';
import MButton from 'components/Mbutton';
import { formatDate } from 'utils';
import { getLastContract } from 'utils';
import PrintButtonExcel from '../default/components/PrintButtonExcel';
import { checkIsValidContractDate } from 'utils';
import { EMPLOYER_STATUS } from 'Constaints';
import { checkIsValidContrat } from 'utils';
import { Related } from './Related';
import MuiCollapse from 'components/MuiCollapse';
import useGroupBySimilarNames from 'hooks/useGroupBySimilarNames';
import MergeEmployeeCard from './MergeEmployeeCard';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EmployesByEnterprise = ({
  openP,
  setOpenP,
  title,
  handleClose,
  Fullscreen,
  selectedEnterprise,
}) => {
  const { t } = useTranslation('employes_by_enterprise');
  const { pid } = useParams();
  let location = useLocation();
  let id = pid ?? selectedEnterprise?.id;

  const [loading, error, employees, fetchData] = useDataFetching(
    id ? `${config.app.api_url}/enterprises/${id}/employers` : null
  );
  const [loadingre, errorre, enterprisesRelateds, fetchrelated] = useDataFetching(
    id ? `${config.app.api_url}/enterprises/${id}/enterprises-related` : null
  );
  const [open, setOpen] = useState(false);
  const [selectedEmployer, setSelectedEmployer] = useState(null);
  const [similarityThreshold, setSimilarityThreshold] = useState(0.75);

  const { groupSimilarNames, groupedNames, loadingGroupedNames } = useGroupBySimilarNames({
    similarityThreshold,
  });
  const headerTable = [
    t('table_column_number'),
    t('table_column_full_name'),
    t('table_column_gender'),
    t('table_column_position'),
    t('table_column_company'),
    t('table_column_salary'),
    t('table_column_nationality'),
    t('table_column_passport_number'),
    t('table_column_permit_number'),
    t('table_column_permit_expiration'),
    t('table_column_permit_status'),
  ];

  const handleClick = (item) => {
    if (item) {
      setSelectedEmployer(item);
      setOpen(true);
    }
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [status, setStatus] = useState(null);
  const [fromArchive, setFromArchive] = useState(null);
  const [filteredDatas, setFilteredDatas] = useState([]);
  const [validDatas, setValidDatas] = useState([]);
  const [dsabledDatas, setDesabledDatas] = useState([]);
  const [showTrash, setshowTrash] = useState(false);
  const [filteredDatasSearch, setFilteredDatasSearch] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [merginMode, setMerginMode] = useState(false);

  useEffect(() => {
    let valid = filteredDatas?.filter(
      (d) => d?.status != EMPLOYER_STATUS?.GONE.value && d?.status != EMPLOYER_STATUS?.DELETED.value
    );
    let desa = filteredDatas?.filter(
      (d) => d?.status == EMPLOYER_STATUS?.GONE.value || d?.status == EMPLOYER_STATUS?.DELETED.value
    );

    setDesabledDatas(desa);
    setValidDatas(valid);
  }, [filteredDatas]);

  useEffect(() => {
    employees?.data && setFilteredDatas(employees?.data);
  }, [employees]);

  useEffect(() => {
    let dd = employees?.data;
    if (fromArchive == -1) {
      dd = employees?.data;
    } else if (fromArchive == 0) {
      dd = employees?.data?.filter((item) => item?.fromArchive != true);
    } else if (fromArchive == 1) {
      dd = employees?.data?.filter((item) => item?.fromArchive == true);
    }

    if (status == -1) {
      dd = dd;
    } else if (status == 0) {
      dd = dd?.filter((item) => {
        return checkIsValidPermit(item) ? item : null;
      });
    } else if (status == 1) {
      dd = dd?.filter((item) => {
        return checkIsValidPermitDate(item) &&
          (item?.permitNumber == null || item?.permitNumber == undefined)
          ? item
          : null;
      });
    } else if (status == 2) {
      dd = dd?.filter((item) => {
        return !checkIsValidPermitDate(item) ? item : null;
      });
    }
    if (searchTerm) {
      dd = dd?.filter((d) => {
        return (d?.fullName + d?.firstName + d?.lastName)
          ?.toLowerCase()
          .includes(searchTerm?.toLowerCase())
          ? d
          : null;
      });
    }
    setFilteredDatas(dd);
  }, [fromArchive, status, searchTerm]);

  const handleCloseInside = () => {
    setFromArchive(null);
    setStatus(null);
    setSearchTerm(null);
    setMerginMode(false);
    handleClose();
  };

  useEffect(() => {
    groupedNames?.length < 1 && setMerginMode(false);
  }, [groupedNames]);

  const columns = getEmployerHeader(t);

  function createData(N, Noms, Poste, Salaire, Nationalité, residentType, Date, Status, Options) {
    return {
      N,
      Noms,
      Poste,
      Salaire,
      Nationalité,
      residentType,
      Date,
      Status,
      Options,
    };
  }

  const rows = (datas) =>
    datas?.map((item, index) => {
      const lastContract = getLastContract(item?.contracts || []);
      return {
        color:
          item?.status == EMPLOYER_STATUS.GONE.value ||
          item?.status == EMPLOYER_STATUS.DELETED.value
            ? 'gray'
            : !checkIsValidContractDate(lastContract)
              ? 'red'
              : '',
        handleClick: () => handleClick(item),
        datas: createData(
          index + 1,
          <>
            {EMPLOYER_STATUS[item?.status]?.icon ? (
              EMPLOYER_STATUS[item?.status]?.icon
            ) : item?.fromArchive == true ? (
              <FromArchiveIcon />
            ) : (
              <FromTheFieldIcon />
            )}
            <span className="fs-c">{item?.fullName || item?.firstName + ' ' + item?.lastName}</span>
          </>,
          lastContract?.occupation?.name,
          item?.enterprise?.socialRaison,
          formatNumber(lastContract?.salary),
          item?.nationality,
          lastContract?.permitDate
            ? dayjs(getExpiredPermitDate(lastContract?.permitDate)).format('DD-MM-YYYY')
            : '--',
          !lastContract?.permitNumber && !lastContract?.permitDate ? (
            <Chip
              color="error"
              variant="outlined"
              className="capitalize-none"
              label={capitalize(t('chip_no_permit'))}
            />
          ) : !checkIsValidContractDate(lastContract) ? (
            <Chip color="error" className="capitalize-none" label={capitalize(t('chip_expired'))} />
          ) : lastContract?.permitNumber ? (
            <Chip
              className="capitalize-none"
              variant="outlined"
              color="success"
              label={t('chip_valid')}
            />
          ) : (
            <Chip
              className="capitalize-none"
              variant="outlined"
              color="warning"
              label={t('chip_to_verify')}
            />
          ),
          <MButton style={{ borderRadius: 20 }} onClick={() => handleClick(item)}>
            {t('button_view')}
          </MButton>
        ),
        history: Array.isArray(item?.contracts)
          ? {
              title: t('history_contracts_title'),
              header: [
                t('table_history_column_salary'),
                t('table_history_column_indemnities'),
                t('table_history_column_permit_number'),
                t('table_history_column_permit_obtained'),
                t('table_history_column_permit_expiration'),
              ],
              datas: item.contracts
                .sort((a, b) => new Date(b?.permitDate) - new Date(a?.permitDate))
                .map((c, index) => {
                  return {
                    index: index,
                    salary: formatNumber(c?.salary),
                    idenmites:
                      (c?.indLogement || 0) +
                      (c?.indTransport || 0) +
                      (c?.indResponsabilite || 0) +
                      (c?.indRepresentation || 0) +
                      (c?.primeExploitation || 0) +
                      (c?.sursalaire || 0) +
                      (c?.primeSalissure || 0) +
                      (c?.indCaisse || 0) +
                      (c?.bonus || 0) +
                      (c?.primePanier || 0) +
                      (c?.billetAvion || 0) +
                      (c?.autresPrimes || 0) +
                      (c?.sursalary || 0),
                    permitOptDate: c?.permitDate ? formatDate(c?.permitDate) : '--',
                    permitDate: c?.permitDate
                      ? formatDate(getExpiredPermitDate(c?.permitDate))
                      : '--',
                    permitNumber: c?.permitNumber || '--',
                  };
                }),
            }
          : [],
      };
    });

  const rowsForSimilarOption = (datas) =>
    datas?.map((data, indexD) => {
      const color = data?.color;
      return data?.people?.map((item, index) => {
        const lastContract = getLastContract(item?.contracts || []);
        return {
          color: color,
          id: item?.id,
          handleClick: () => handleClick(item),
          datas: createData(
            <span className="ms-2">{index + 1}</span>,
            <>
              {EMPLOYER_STATUS[item?.status]?.icon ? (
                EMPLOYER_STATUS[item?.status]?.icon
              ) : item?.fromArchive == true ? (
                <FromArchiveIcon />
              ) : (
                <FromTheFieldIcon />
              )}
              <span className="fs-c">
                {item?.fullName || item?.firstName + ' ' + item?.lastName}
              </span>
            </>,
            lastContract?.occupation?.name,
            item?.enterprise?.socialRaison,
            formatNumber(lastContract?.salary),
            item?.nationality,
            lastContract?.permitDate
              ? dayjs(getExpiredPermitDate(lastContract?.permitDate)).format('DD-MM-YYYY')
              : '--',
            !lastContract?.permitNumber && !lastContract?.permitDate ? (
              <Chip
                color="error"
                variant="outlined"
                className="capitalize-none"
                label={capitalize(t('chip_no_permit'))}
              />
            ) : !checkIsValidContractDate(lastContract) ? (
              <Chip
                color="error"
                className="capitalize-none"
                label={capitalize(t('chip_expired'))}
              />
            ) : lastContract?.permitNumber ? (
              <Chip
                className="capitalize-none"
                variant="outlined"
                color="success"
                label={t('chip_valid')}
              />
            ) : (
              <Chip
                className="capitalize-none"
                variant="outlined"
                color="warning"
                label={t('chip_to_verify')}
              />
            ),
            <MButton style={{ borderRadius: 20 }} onClick={() => handleClick(item)}>
              {t('button_view')}
            </MButton>
          ),
          history: [],
        };
      });
    });

  useEffect(() => {
    groupSimilarNames && validDatas && groupSimilarNames({ people: validDatas });
  }, [validDatas]);

  useEffect(() => {
    validDatas && rows(validDatas);
  }, [validDatas]);

  return (
    <React.Fragment>
      <Dialog
        fullScreen={Fullscreen}
        open={openP}
        onClose={handleCloseInside}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar className="bg-gray-50 flex justify-between">
            <IconButton title={t('tooltip_back')}>
              <BsArrowLeftCircleFill size={40} color={'red'} onClick={handleCloseInside} />
            </IconButton>
            <span className="flex flex-col align-center">
              <Typography color={'green'} sx={{ ml: 2 }} variant="h6" component="div">
                {`${selectedEnterprise?.sigle ? '(' + selectedEnterprise?.sigle + ')' : ''} ${
                  selectedEnterprise?.socialRaison
                }`}
              </Typography>
              <Typography color={'blue'} variant="subtitle2" textAlign={'center'} component="div">
                NIU: {selectedEnterprise?.nui}
              </Typography>
            </span>
            <TextField
              style={{
                width: '30%',
                color: 'white',
                background: 'rgba(255,255,255,0.3)',
                border: 'none',
              }}
              className="text-white"
              variant="filled"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={t('search_placeholder')}
              id="outlined-search"
              type="search"
              color="success"
            />
            <div className="flex justify-center gap-2">
              <Fab variant="extended" onClick={() => setOpen(true)} sx={{ mr: 2 }} color="green">
                <BsPlus size={30} />
                {t('button_add')}
              </Fab>
              <MuiSelect
                dataCy="filter-employee-source"
                value={fromArchive}
                label={t('select_source_label')}
                options={[
                  { value: -1, label: t('select_source_all') },
                  { value: 0, label: t('select_source_field') },
                  { value: 1, label: t('select_source_archive') },
                ]}
                onChange={(event) => setFromArchive(event.target.value)}
              />
              <MuiSelect
                dataCy="filter-employee-status"
                value={status}
                label={t('select_status_label')}
                options={[
                  { value: -1, label: t('select_status_all') },
                  { value: 0, label: t('select_status_valid') },
                  { value: 1, label: t('select_status_to_verify') },
                  { value: 2, label: t('select_status_expired') },
                  { value: 3, label: t('select_status_no_contract') },
                ]}
                onChange={(event) => setStatus(event.target.value)}
              />
            </div>
          </Toolbar>
        </AppBar>
        {(loading || loadingGroupedNames) && <PreloaderSpinner />}
        <AddEmployer
          get={fetchData}
          open={open}
          handleClose={() => {
            setSelectedEmployer(null);
            setOpen(false);
          }}
          selectedEmployerP={selectedEmployer}
          fixedEnterprise={selectedEnterprise}
        />
        <div className="m-2 w-100 flex justify-end items-center gap-2">
          <PrintButtonExcel
            text={t('button_export_excel')}
            filename={`expatriés_${selectedEnterprise?.socialRaison?.trim()?.replaceAll('.', '')}_${dayjs(
              new Date()
            )?.format('DD/MM/YYYY')}`}
            header={headerTable}
            body={
              validDatas?.length > 0 &&
              validDatas?.map((e, i) => {
                const l = getLastContract(e?.contracts || []);
                return [
                  i + 1,
                  e?.fullName || e?.firstName + ' ' + e?.lastName,
                  e?.sexe,
                  l?.occupation?.name,
                  e?.enterprise?.socialRaison,
                  l?.salary,
                  e?.nationality,
                  l?.passportNumber,
                  l?.permitNumber,
                  l?.permitDate
                    ? dayjs(getExpiredPermitDate(l?.permitDate)).format('DD-MM-YYYY')
                    : '--',
                  !checkIsValidContrat(l) ? t('chip_expired') : t('chip_valid'),
                ];
              })
            }
          />
          {showTrash ? (
            <BsBoxArrowLeft onClick={() => setshowTrash(false)} size={25} />
          ) : (
            <BsTrash2Fill onClick={() => setshowTrash(true)} size={24} />
          )}
        </div>
        <div className="grid h-full grid-cols-1 gap-5">
          <Card extra={'w-full h-full p-4'}>
            <div className="flex flex-col content-center text-center rounded-lg shadow mb-3">
              <strong className="text-xl uppercase w-full bg-green-200">
                {location?.state?.enterprise?.socialRaison}
              </strong>
              <div className="flex justify-center mt-2">
                <strong>
                  {t('badge_total_label')}
                  <Badge
                    fontSize={13}
                    rounded={5}
                    padding={1}
                    paddingInline={2}
                    colorScheme="green"
                    className="mx-1"
                  >
                    {formatNumber(showTrash ? dsabledDatas?.length : validDatas?.length) || '--'}
                  </Badge>
                </strong>
                {!showTrash && (
                  <>
                    <strong>
                      {t('badge_field_label')}
                      <Badge
                        fontSize={13}
                        rounded={5}
                        padding={1}
                        paddingInline={2}
                        colorScheme="blue"
                        className="mx-1"
                      >
                        {formatNumber(validDatas?.filter((e) => !e?.fromArchive)?.length) || '--'}
                      </Badge>
                    </strong>
                    <strong>
                      {t('badge_archive_label')}
                      <Badge
                        fontSize={13}
                        rounded={5}
                        padding={1}
                        paddingInline={2}
                        colorScheme="yellow"
                        className="mx-1"
                      >
                        {formatNumber(validDatas?.filter((e) => e?.fromArchive)?.length) || '--'}
                      </Badge>
                    </strong>
                    <strong>
                      {t('badge_branches_label')}
                      <Badge
                        fontSize={13}
                        rounded={5}
                        padding={1}
                        paddingInline={2}
                        colorScheme="yellow"
                        className="mx-1"
                      >
                        {formatNumber(enterprisesRelateds?.data?.length) || '--'}
                      </Badge>
                    </strong>
                    <strong>
                      {t('badge_deleted_label')}
                      <Badge
                        fontSize={13}
                        rounded={5}
                        padding={1}
                        paddingInline={2}
                        colorScheme="red"
                        className="mx-1"
                      >
                        {formatNumber(dsabledDatas?.length) || '--'}
                      </Badge>
                    </strong>
                  </>
                )}
              </div>
            </div>
            {groupedNames && groupedNames?.length > 0 && (
              <Alert severity="error" className="mb-2 text-center justify-center">
                <div className="flex gap-1 items-center">
                  <AlertTitle>
                    {groupedNames?.length} {t('alert_similar_employees')}
                  </AlertTitle>
                  <MButton variant="danger" size="small" onClick={() => setMerginMode(!merginMode)}>
                    {merginMode ? t('button_cancel_merge') : t('button_activate_merge')}
                  </MButton>
                </div>
              </Alert>
            )}
            {!showTrash && validDatas && !merginMode && (
              <MuiTable
                hidePagiation={true}
                columns={columns}
                withHistory={false}
                rows={rows(validDatas)}
                dataCy="employees-table"
              />
            )}
            {!showTrash &&
              validDatas &&
              groupedNames &&
              merginMode &&
              rowsForSimilarOption(groupedNames)?.map((data, index) => {
                return (
                  <MergeEmployeeCard
                    columns={columns}
                    employees={data}
                    index={index}
                    setSelecetdEmployee={setSelectedEmployer}
                    setOpenEmployeeModal={setOpen}
                    fetchEMployees={fetchData}
                  />
                );
              })}
            {showTrash && (
              <>
                <Divider />
                <div className="flex gap-1 content-center items-center mt-[75px]">
                  <BsTrash2Fill size={25} color="red" />
                  <Typography variant="h5">{t('trash_title')}</Typography>
                </div>
                {dsabledDatas && (
                  <MuiTable
                    hidePagiation={true}
                    columns={columns}
                    rows={rows(dsabledDatas)}
                    dataCy="employees-table"
                  />
                )}
              </>
            )}
            {filteredDatas?.length == 0 && <NotFoundResults />}
            <div>
              <MuiCollapse
                title={
                  <div className="flex gap-1 items-center">
                    <Typography variant="h5">{t('collapse_branches_title')}</Typography>
                    <Badge
                      fontSize={13}
                      rounded={5}
                      padding={1}
                      paddingInline={2}
                      colorScheme="green"
                      className="mx-1"
                    >
                      {formatNumber(enterprisesRelateds?.data?.length) || '--'}
                    </Badge>
                  </div>
                }
                bgColor={'rgba(100,1,1,0.1)'}
              >
                {enterprisesRelateds?.data?.length > 0 &&
                  enterprisesRelateds?.data?.map((r, index) => {
                    return <Related key={index} rows={rows} columns={columns} enterprise={r} />;
                  })}
              </MuiCollapse>
            </div>
          </Card>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default EmployesByEnterprise;
